import React from "react";
import PropTypes from "prop-types";
import SmartDialog from "../../SmartDialog";
import Icon from "react-icons-kit";
import CheckOptionView from "../../../common/CheckOptionView/CheckOptionView";
import {Button} from "reactstrap";
import {ic_sort as SortIcon} from 'react-icons-kit/md/ic_sort';

class SortDialog extends React.Component{

    static propTypes = {
        onApply: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState(sortStr = "",columns = []){

        const parts = !sortStr ? [] : sortStr.split(",");

        return {

            selectionState: parts.map(x => {

                return {
                    value: x.replace("-",""),
                    checked: true,
                    mode: x.startsWith("-") ? "desc" : "asc"
                };

            }).concat(columns.filter(x => sortStr.indexOf(x.value) < 0 ).map(x => {

                return {
                    value: x.value,
                    checked: false,
                    mode: "asc"
                };
            })),

            columns: columns
        };

    }

    show(sortStr,columns){

        this.setState(this.getInitialState(sortStr,columns),() => {
            return this._dlg.show();
        });

    }

    toggle(){
        return this._dlg.toggle();
    }

    onSaveChanges(){

        const colUnique = this.state.selectionState.filter(x => x.checked).map(x => (x.mode === "desc" ? "-" : "" )  + x.value ).join(",");

        if(this.props.onApply){
            this.props.onApply(colUnique);
        }

        this._dlg.toggle();
    }

    _findState(value){
        return this.state.selectionState.find(x => x.value === value );
    }

    render(){

        const state = this.state;

        return <SmartDialog title={<span><Icon size={32} icon={SortIcon}/> Configure Sort</span>} ref={r => this._dlg = r}>

            <div style={{ marginBottom: 8 }}>
                <p className="ml-3">Check the columns to sort</p>
                {state.columns.map((c,index) => {

                    const isChecked = this._findState(c.value).mode === "asc";
                    const isActive = this._findState(c.value).checked;

                    return <div className="row mb-2" key={index}>

                        <div className="col-md-2 col-sm-2">
                            <CheckOptionView value={isActive} containerClasses="mt-0" switchClass="primary"  onChange={checked => {

                                this._findState(c.value).checked = checked;

                                this.setState({
                                    selectionState: this.state.selectionState
                                });

                            }}/>
                        </div>

                        <div className="col-md-8 col-sm-8">
                            <small style={{ color: isActive ? '' : '#969696'}}><b>{c.label}</b></small>
                        </div>

                        <div className="col-md-2 col-sm-2">

                            <div style={{ opacity: isActive ? 1 : 0.4 }}>
                                <CheckOptionView value={isChecked}
                                                 containerClasses="mt-0" switchClass="success" offText="DESC" onText="ASC" onChange={checked => {

                                    this._findState(c.value).mode =  checked ? "asc" : "desc";

                                    this.setState({
                                        selectionState: this.state.selectionState
                                    });

                                }} />
                            </div>

                        </div>

                    </div>
                })}

            </div>

            <hr/>

            <div className="clearfix">

                <div className="pull-right">
                    <Button color="green" style={{ borderRadius: 4 , marginTop: 10 }} onClick={this.onSaveChanges.bind(this)}><i className="fa fa-edit"></i> Save Changes</Button>
                </div>

            </div>

        </SmartDialog>
    }

}

export default SortDialog;


// WEBPACK FOOTER //
// ./src/components/CRUDView/Components/SortDialog.js